import { X } from 'lucide-react';
import { useState } from 'react';

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

type Props = {
  onDiscard: () => void;
};

const ExitAlertDialog = ({ onDiscard }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const onKeepEditing = () => setIsOpen(false);

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogTrigger asChild>
        <Button
          size="icon"
          variant="outline"
          className="shadow-none sm:absolute sm:top-5 sm:right-6 sm:z-2"
          aria-label="Exit"
        >
          <X />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure you want to discard your changes?</AlertDialogTitle>
          <AlertDialogDescription>
            Suggested changes won’t be saved until you click Submit changes.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={onDiscard}>
            Discard changes
          </Button>
          <Button onClick={onKeepEditing}>Keep editing</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ExitAlertDialog;
